/** @format */

import {
    ORDER_STATUS_WAITING_ON_CUSTOMER,
    ORDER_STATUS_PREPRINTING_CUE,
    PRODUCT_TYPE_GRAPHIC_DESIGN,
    PRODUCT_TYPE_CARTON
} from 'frontier-constants';
import UploadDesigns from '@/account/components/upload_designs/container';
import {If, AdaptiveImage, IfElse} from 'frontier-utilities';
import {Modal, ModalHeader} from '@sttark/design-system';
import {PROOF_STATUS_PENDING} from 'frontier-constants';
import NumberFormat from 'react-number-format';
import React, {useState} from 'react';

// styles
import './order_action_column.scss';

export const OrderActionColum = props => {
    const {cart, order} = props;

    const [uploadedDesigns, setUploadedDesigns] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const shouldDisplayShippingSummary =
        cart.is_shipped && order.product_type_id !== PRODUCT_TYPE_GRAPHIC_DESIGN;

    const isWaitingOnCustomer = order.status_id === ORDER_STATUS_WAITING_ON_CUSTOMER;
    const isInPrintingCue = order.status_id === ORDER_STATUS_PREPRINTING_CUE;

    const canReplaceArtwork =
        (isWaitingOnCustomer || isInPrintingCue) &&
        (order.latest_proof?.status === PROOF_STATUS_PENDING || !order.latest_proof) &&
        !order.is_reorder;

    // only include these base order properties when redirecting to the quoter from
    // create new order action button
    const orderPropertiesArray = [
        'is_variable_print_only',
        'is_design_in_progress',
        'is_printed_proof_only',
        'is_flat_printed_proof',
        'is_high_opacity_black',
        'is_high_opacity_white',
        'is_special_roll_qty',
        'quoter_version_id',
        'is_square_corners',
        'roll_direction_id',
        'is_variable_data',
        'is_reverse_print',
        'product_type_id',
        'processing_id',
        'proof_type_id',
        'substrate_id',
        'laminate_id',
        'is_duplex',
        'color_id',
        'shape_id',
        'is_blank',
        'size_id',
        'length',
        'width',
        'depth'
    ];

    let productType = 'labels';
    if (order.product_type_id === PRODUCT_TYPE_CARTON) productType = 'cartons';
    if (order.product_type_id === PRODUCT_TYPE_GRAPHIC_DESIGN) productType = 'designs';

    const newOrderFromPropertiesPath =
        `/orders/custom-${productType}?` +
        Object.keys(order)
            .filter(key => orderPropertiesArray.includes(key))
            .map(key => `${key}=${order[key]}`)
            .join('&');

    return (
        <div className="single-active-order-10cn__column--action">
            <a
                className="color-accent-primary d-flex align-items-center justify-content-start"
                href={newOrderFromPropertiesPath}
                rel={'noopener noreferrer'}
                target={'_blank'}>
                <i className="fa fa-clock-rotate-left me-2" />
                <u>Create new order</u>
            </a>
            <If condition={shouldDisplayShippingSummary}>
                <div>
                    <a
                        className="color-accent-primary d-flex align-items-center justify-content-start"
                        href={`/account/orders/preview-cart-summary/${cart.id}`}
                        rel="noopener noreferrer"
                        target="_blank">
                        <i className="fa fa-truck me-2" />
                        <u>Shipping Summary</u>
                    </a>
                </div>
            </If>
            <If condition={canReplaceArtwork}>
                <button
                    onClick={() => setIsModalOpen(!isModalOpen)}
                    className="p-0 m-0 color-accent-primary d-flex align-items-center justify-content-start">
                    <i className="fa fa-pencil me-2" />
                    <u>Replace Artwork</u>
                </button>
            </If>
            <Modal
                isOpen={isModalOpen}
                zIndex={3000}
                bodyHeightAuto
                onClose={() => {
                    if (uploadedDesigns.length > 0) {
                        setIsModalOpen(false);
                    } else if (
                        confirm(
                            'Are you sure you want to close this modal? All unsaved changes will be lost.'
                        )
                    ) {
                        setIsModalOpen(false);
                    }
                }}>
                <ModalHeader>Upload Designs</ModalHeader>
                <section>
                    <IfElse condition={uploadedDesigns.length === 0}>
                        <UploadDesigns
                            orderId={order.id}
                            isAdmin={false}
                            designsOrders={order.designs_orders}
                            onSave={designsOrders => {
                                setUploadedDesigns(designsOrders);
                            }}
                        />
                        <div>
                            <div
                                className="alert alert-success"
                                style={{
                                    backgroundColor: 'rgba(25, 135, 84, 0.1)',
                                    color: '#198754'
                                }}>
                                Designs Updated!
                            </div>
                            {uploadedDesigns.map(dos => {
                                return (
                                    <div key={dos.id} className="mb-4">
                                        <div className="d-flex align-items-center justify-content-start gap-3 bg-structure-light">
                                            <b className="d-blok px-4 py-2">
                                                <NumberFormat
                                                    value={dos.qty}
                                                    thousandSeparator={true}
                                                    displayType="text"
                                                />
                                            </b>
                                            {dos.design.customer_version_count > 0 && (
                                                <p style={{fontSize: '18px'}} className="p-0 m-0">
                                                    <span className="badge text-bg-secondary">
                                                        Version:{' '}
                                                        {dos.design.customer_version_count + 1}
                                                    </span>
                                                </p>
                                            )}
                                            <div className="m-0 p-0">{dos.filename}</div>
                                        </div>
                                        <div className="w-100 p-2 bg-structure-lightest">
                                            <AdaptiveImage src={dos.signed_url} width={250} />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </IfElse>
                </section>
            </Modal>
        </div>
    );
};
